<template>
    <v-app>
        <v-container>
            <v-row>
                <h3>Editar Rol</h3>
            </v-row>
                        <v-row class="mt-5">
                <v-btn color="info" @click="$router.push('/role')">Volver Al Global</v-btn>
            </v-row>
            <v-row class="mt-5">
                <v-col lg="3" class="text-right bold mr-5">
                    Nombre
                </v-col>
                <v-col lg="6">
                    <v-text-field
                        name="name"
                        label="Nombre del Rol"
                        id="nombre"
                        v-model="role.name"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col lg="12" class="text-center">
                    <v-btn color="info" class="mr-5" @click="setData">Guardar</v-btn>
                    <v-btn color="error" class="ml-5" @click="delData">Eliminar</v-btn>
                </v-col>
                
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
            role:{
                name: ''

            }
        }
    },methods:{
        setData: async function(){
            try {
                let {data} = axios.post(`https://127.0.0.1:3000/role/${this.$route.params.id}`,this.role)
                this.role=data
            } catch (error) {
                //console.log(error)
                
            }

        },
        delData: async function(){
            try {
                axios.delete(`https://127.0.0.1:3000/role/${this.$route.params.id}`)
                //console.log(data)
                this.$router.push('/role/')
            } catch (error) {
                //console.log(error)
                
            }

        },
        getData: async function(){
            try {
                let {data} = await axios.get(`https://127.0.0.1:3000/role/${this.$route.params.id}`)
                this.role=data
            } catch (error) {
                //console.log(error)
                
            }


        }
    },
    mounted(){
        this.getData()
    }
}
</script>

<style>
    .bold{
        font-weight: bolder
    }
</style>